import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Facility } from '@reliance/types/models/Facility';
import { AxiosResponse } from 'axios';
import api from '../common/api';

export type FacilitiesState = {
  facilitiesLoading: boolean;
  facilities: Facility[];
};

const initialState: FacilitiesState = {
  facilitiesLoading: false,
  facilities: [],
};

export const loadFacilities = async (dispatch) => {
  dispatch(facilitiesLoading());
  const facilities = await api.get('/facility?active=false').then((response: AxiosResponse<Facility[]>) => response.data);
  dispatch(facilitiesLoaded(facilities));
}

export const alertsSlice = createSlice({
  name: 'facilities',
  initialState,
  reducers: {
    facilitiesLoading: (state) => {
      state.facilitiesLoading = true;
    },
    facilitiesLoaded: (state, action: PayloadAction<Facility[]>) => {
      state.facilities = action.payload;
      state.facilitiesLoading = false;
    },
  },
});

export const {
  facilitiesLoading,
  facilitiesLoaded
} = alertsSlice.actions;

export default alertsSlice.reducer;